import { render, staticRenderFns } from "./ModelagemCarteira.vue?vue&type=template&id=03f7a914&scoped=true"
import script from "./ModelagemCarteira.vue?vue&type=script&lang=js"
export * from "./ModelagemCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7a914",
  null
  
)

export default component.exports